import { Input, type InputProps } from '@chakra-ui/react'
import { useMask } from '@react-input/mask'
import { forwardRef } from 'react'

const CepInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, _ref) => {
  const inputRef = useMask({
    mask: '_____-___',
    replacement: { _: /\d/ },
  })

  return <Input {...props} ref={inputRef} type="text" />
})

export default CepInput
